import actions from './actions';
import axiosServices from '@services/axiosServices';
import { API_HOST, API } from '@configs/api';
import actionsAlert from '../alert/actions';
import announcementModalActions from '../modals/announcement/actions';
import axios from 'axios';
import authActions from '@store/authentification/actions';

import { setToken, setUserRole, getUser, setRefreshToken } from '@services/authentificationServices';
import { ACCOUNT_NOT_VERIFIED, ACCOUNT_DISABLED } from '@helpers/strings';
import { getUserEmail } from '@services/authentificationServices';

const { loginSuccess } = authActions;

const { getAllCandidature, getAllProposedCandidate } = actions;
const { alert } = actionsAlert;
const { successModal, errorModal } = announcementModalActions;

const getAllCandidatures = (data, page) => {
    const URL = API_HOST + API.candidature.allCandidature;
    return async (dispatch) => {
        axiosServices.post(URL, data, { params: page }).then(
            (res) => {
                dispatch(getAllCandidature(res.data));
            },
            (err) => {
                console.log(err);
            },
        );
    };
};

const getAllProposedCandidates = (data, page) => {
    const URL = API_HOST + API.candidature.proposedCandidate;
    return async (dispatch) => {
        axiosServices.post(URL, data, { params: page }).then(
            (res) => {
                dispatch(getAllProposedCandidate(res.data));
            },
            (err) => {
                console.log(err);
            },
        );
    };
};

const cancelCandidature = (data, dataSearch, page, onClose) => {
    const URL = API_HOST + API.candidature.cancelCandidature + data.id;
    return async (dispatch) => {
        axiosServices.delete(URL).then(
            (res) => {
                onClose();
                dispatch(getAllCandidatures(dataSearch, page));
                dispatch(alert({ msg: 'success_operation', type: 'success' }));
            },
            (err) => {
                dispatch(alert({ msg: 'failed_operation', type: 'error' }));
            },
        );
    };
};

const handlingNotinterrested = (data, dataSearch, page) => {
    const URL = API_HOST + API.favorite.handleFavourites;
    return async (dispatch) => {
        axiosServices.post(URL, data).then(
            (res) => {
                dispatch(getAllProposedCandidates(dataSearch, page));
                dispatch(alert({ msg: 'success_operation', type: 'success' }));
            },
            (err) => {
                dispatch(alert({ msg: 'failed_operation', type: 'error' }));
            },
        );
    };
};

//TODO: Optimize and refactor the code
const applyMission = (data, dataListing, page, setCenteredModal, onClose, jobTitle) => {
    const URL = API_HOST + API.candidature.applyJobOfferAuthenticatedUser.replace('missionId', data.missionId);
    const email = getUserEmail();
    if (!email) return false;

    data.email = email;

    return async (dispatch) =>
        axiosServices.post(URL, data).then(
            (res) => {
                if (data.qualification) setCenteredModal(false);
                onClose();
                dispatch(getAllProposedCandidates(dataListing, page));
                dispatch(
                    alert({
                        msg: 'success_apply_mission',
                        signature: 'team_valjob',
                        jobTitle: jobTitle,
                        type: 'success',
                    }),
                );
            },
            (err) => {
                if (err.response.data.message === 'candidature  already exists')
                    dispatch(alert({ msg: 'candidature_exist', type: 'error' }));
                else dispatch(alert({ msg: 'failed_operation', type: 'error' }));
            },
        );
};

const applyMissionPostulation = (data, title) => {
    const URL = API_HOST + API.candidature.applyCandidature;
    return async (dispatch) =>
        axiosServices.post(URL, data).then(
            (res) => {
                dispatch(
                    alert({
                        msg: 'success_apply_mission',
                        signature: 'team_valjob',
                        jobTitle: title,
                        redirectLink: 'access_account',
                        type: 'success',
                    }),
                );
            },
            (err) => {
                if (err.response.data.message === 'candidature  already exists')
                    dispatch(alert({ msg: 'candidature_exist', type: 'error' }));
                else dispatch(alert({ msg: 'failed_operation', type: 'error' }));
            },
        );
};

//TODO: Optimize and refactor the code
const announcementApply = (data, announcementId, announcementTitle, source, isAuthenticated) => {
    let POSTULATION_URL = API_HOST + API.candidature.applyJobOfferAuthenticatedUser.replace('missionId', announcementId);
    if (isAuthenticated === false){
        POSTULATION_URL = API_HOST + API.candidature.applyJobOfferAnonymousUser.replace('missionId', announcementId);
    }

    return async (dispatch) =>
        await axiosServices.post(POSTULATION_URL, data).then(
            (res) => {
                dispatch(
                    successModal({
                        modalType: 'success',
                        announcementStatus: res.data.status,
                        hash: res.data.hash,
                        announcementTitle,
                        announcementId,
                        source,
                    }),
                );
            },
            (err) => {
                dispatch(errorModal({ modalType: 'error', announcementStatus: err.response.data.status }));
            },
        );
};

const checkExistMailPostulation = (data, setErrorEmailExist) => {
    const URL = API_HOST + API.auth.checkExistMail;
    return async (dispatch) => {
        axios.post(URL, data).then(
            (res) => {
                if (res.data.status === ACCOUNT_DISABLED) {
                    dispatch(errorModal({ modalType: 'error', announcementStatus: res.data.status }));
                }
                setErrorEmailExist(true);
            },
            (err) => {
                setErrorEmailExist(false);
            },
        );
    };
};

const announcementApplyById = (data, announcementId, announcementTitle, source, dataConnexion) => {
    const AUTH_URL = API_HOST + API.auth.login;
    dataConnexion.is_candidate = true;

    return async (dispatch) => {
        await axios.post(AUTH_URL, dataConnexion).then(
            (authResponse) => {
                if (authResponse.data.status === ACCOUNT_DISABLED) {
                    dispatch(errorModal({ modalType: 'error', announcementStatus: authResponse.data.status }));
                } else {
                    setToken(authResponse.data.token);
                    setRefreshToken(authResponse.data.refresh_token);
                    setUserRole(getUser(authResponse.data.token).roles[0]);
                    dispatch(loginSuccess(authResponse.data.token));

                    dispatch(announcementApply(data, announcementId, announcementTitle, source, true));
                }
            },
            (authError) => {
                if (authError.response.data.status === ACCOUNT_NOT_VERIFIED) {
                    dispatch(announcementApply(data, announcementId, announcementTitle, source, true));
                } else {
                    dispatch(errorModal({ modalType: 'error', announcementStatus: authError.response.data.status }));
                }
            },
        );
    };
};

const setCandidatureStatus = (candidateId) => {
    const URL = `${API_HOST}${API.candidature.setCandidatureStatus}`;

    return async (dispatch) => axiosServices.post(URL, { id: candidateId }).then((response) => response.data);
};

export {
    applyMissionPostulation,
    getAllCandidatures,
    getAllProposedCandidates,
    cancelCandidature,
    handlingNotinterrested,
    applyMission,
    setCandidatureStatus,
    announcementApplyById,
    checkExistMailPostulation,
    announcementApply,
};
